import './AddNewCommentSection.style.less'
import CommentFieldInput from '../CommentFieldInput/CommentFieldInput'
import { ICommentDataField } from '../../CommentFieldDialog.interface'
import { queryClient } from '@/config/react-query'

interface Prop {
  data: any
  comment: ICommentDataField
}

function AddNewCommentSection(props: Prop) {
  const { data } = props
  return (
    <div>
      <div className="mt-4">
        <CommentFieldInput
          onReload={async () => {
            await queryClient.refetchQueries(['commentQuery'])
            await queryClient.refetchQueries(['GET_COMMENT_COUNT', data?.id])
          }}
          section="byOrderId"
          onClose={() => {}}
          data={data}
          taskId={data?.id}
        />
      </div>
    </div>
  )
}

export default AddNewCommentSection
